<template>
    <div class="py-4">
        <h4 class="text-center font-active">Shop Wedding Rings & Anniversary Bands</h4>
        <div class="row mt-4 pt-3">
            <div class="col-md-3 col-6 text-center">
                <NuxtLink :to="localePath({ name:'shop-womens-wedding-rings' })">
                    <picture>
                    <source width="278" height="278" type="image/webp" srcset="~/assets/landing/wedding/anniversory/women.webp">
                    <img class="radious_eight" loading="lazy" width="278" height="278" type="image/jpeg" alt="Women’s Wedding rings" src="~/assets/landing/wedding/anniversory/women.jpg">
                    </picture>
                    <h6 class="mb-0">Women’s Wedding rings <span>Beautiful rings for beautiful brides.</span></h6>
                </NuxtLink>
            </div>
            <div class="col-md-3 col-6 text-center">
                <NuxtLink :to="localePath({ name:'shop-eternity' })">
                    <picture>
                    <source width="278" height="278" type="image/webp" srcset="~/assets/landing/wedding/anniversory/eternity.webp">
                    <img class="radious_eight" loading="lazy" width="278" height="278" alt="Eternity Rings" type="image/jpeg" src="~/assets/landing/wedding/anniversory/eternity.jpg">
                    </picture>
                    <h6 class="mb-0">Eternity Rings <span>Infinity rings embellished with diamonds.</span></h6>
                </NuxtLink>
            </div>
            <div class="col-md-3 col-6 text-center">
                <NuxtLink :to="localePath({ name: 'shop-anniversary',  query:{'Style': 'Five-stone'}})">
                    <picture>
                    <source width="278" height="278" type="image/webp" srcset="~/assets/landing/wedding/anniversory/anniversory.webp">
                    <img class="radious_eight" loading="lazy" width="278" height="278" alt="Anniversary Rings" type="image/jpeg" src="~/assets/landing/wedding/anniversory/anniversory.jpg">
                    </picture>
                    <h6 class="mb-0">Anniversary Rings <span>Rings to celebrate your special milestone.</span></h6>
                </NuxtLink>
            </div>
            <div class="col-md-3 col-6 text-center">
                <NuxtLink :to="localePath({ name:'shop-couple-rings' })">
                    <picture>
                    <source width="278" height="278" type="image/webp" srcset="~/assets/landing/wedding/anniversory/couple.webp">
                    <img class="radious_eight" loading="lazy" width="278" height="278" alt="Couple Bands" type="image/jpeg" src="~/assets/landing/wedding/anniversory/couple.jpg">
                    </picture>
                    <h6 class="mb-0">Couple Bands <span>Matching his & her designs.</span></h6>
                </NuxtLink>
            </div>
        </div>
    </div>
</template>


<script setup>
    const localePath = useLocalePath()
</script>


<style scoped>

h4{
    font-size: 32px;
    text-transform: capitalize;
}
a{
    color: #000;
    display: inline-block;
} 
span{
    display: block;
    text-align: center;
  
    padding-top: 4%;
    font-weight: 400;
}
h6 {
    font-weight: 600;
    font-size: 16px;
    padding-top: 8%;
}
@media(max-width: 992px){
    h4{
        font-size: 24px;
    }
}
@media(max-width: 767px){
   
    a{
        margin-bottom: 12%;
    }
    h6 {
        font-size: 14px;
    }
}
</style>